import { render, staticRenderFns } from "./arrowBack.vue?vue&type=template&id=3fe5e536&"
import script from "./arrowBack.vue?vue&type=script&lang=js&"
export * from "./arrowBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports